import { render, staticRenderFns } from "./PaasSolution.vue?vue&type=template&id=d56a4e24&scoped=true&"
import script from "./PaasSolution.vue?vue&type=script&lang=js&"
export * from "./PaasSolution.vue?vue&type=script&lang=js&"
import style0 from "./PaasSolution.vue?vue&type=style&index=0&id=d56a4e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56a4e24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VDialog,VIcon,VTextField})
